import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Lightbox from 'react-images';
import format from 'date-fns/format';
import axios from 'axios';
import useSlides from '../hooks/useSlides';
import InstagramPost from './InstagramPost';
import LightboxCaption from './LightboxCaption';
import SliderArrow from './SliderArrow';
import LoadingCard from './Loading/LoadingCard';

export function CloseLightbox(props) {
  return (
    <button
      aria-label="Close Lightbox"
      name="Close Lightbox"
      className="close-lightbox"
      type="button"
      {...props}
    >
      {/* Times svg */}
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="0.646447"
          y1="12.6464"
          x2="12.6464"
          y2="0.646446"
          stroke="#FFFFFF"
        />
        <line
          y1="-0.5"
          x2="16.9706"
          y2="-0.5"
          transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 12 13)"
          stroke="#FFFFFF"
        />
      </svg>
    </button>
  );
}

export default function InstagramSlider({ isHomeSlider, feed }) {
  const sliderRef = useRef(null);
  const slideCount = useSlides({ sliderRef, cardWidth: 220 });

  if (!slideCount) {
    console.error("slideCount doesn't exist!");
  }

  const [showLightbox, toggleLightbox] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const [posts, setPosts] = useState([]);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slideCount || 3,
    slidesToScroll: slideCount || 3,
    arrows: true,
    prevArrow: <SliderArrow type="instagram" direction="prev" />,
    nextArrow: <SliderArrow type="instagram" direction="next" />,
  };

  const fetchPosts = async () => {
    // TODO: Move key to variable
    const { data } = await axios.get('/dZz2O9LP8jtO7XwHYUPh/instagram_feed');
    setPosts([...data.home]);
  };

  // Fetch instagram posts
  useEffect(() => {
    if (isHomeSlider) fetchPosts();
    else setPosts(feed);
  }, [feed, isHomeSlider]);

  const sliderPosts = posts
    .filter(post => post.media_type === 'IMAGE')
    .map((post, ind) => (
      <InstagramPost
        key={ind}
        toggleLightbox={toggleLightbox}
        setImageIndex={setImageIndex}
        index={ind}
        post={post}
      />
    ));

  return (
    <div ref={sliderRef} className="instagram--slider__container">
      <Lightbox
        onClose={() => toggleLightbox(false)}
        onClickNext={() => setImageIndex(imageIndex + 1)}
        onClickPrev={() => setImageIndex(imageIndex - 1)}
        currentImage={imageIndex}
        isOpen={showLightbox}
        images={posts
          .filter(post => post.media_type === 'IMAGE')
          .map(post => ({
            src: post.media_url,
            caption: (
              <LightboxCaption
                author={post.username}
                date={format(post.timestamp, 'MMMM D, YYYY')}
                permalink={post.permalink}
              />
            ),
          }))}
        onClickThumbnail={e => setImageIndex(e)}
        customControls={[
          <CloseLightbox onClick={() => toggleLightbox(false)} />,
        ]}
        closeButtonTitle="closeLightbox"
        leftArrowTitle="leftLightboxArrow"
        rightArrowTitle="rightLightboxArrow"
        showImageCount={false}
        showThumbnails
      />
      <Slider {...settings}>
        {posts.length
          ? sliderPosts
          : [...Array(slideCount)].map((_, ind) => (
              <LoadingCard key={ind} card_type="instagram" />
            ))}
      </Slider>
    </div>
  );
}

InstagramSlider.propTypes = {
  isHomeSlider: PropTypes.bool,
  feed: PropTypes.array,
};
